import { MainContainer } from '@/components';
import { recheckProcessTranslation } from '@/helpers/recheckProcessTranslation';
import { useTranslation } from '@/hooks';
import { Helmet } from 'react-helmet';

import PageHeader from '../PageHeader';

export function VerificationError() {
  const { translate } = useTranslation({ useAnonymously: true });

  return (
    <>
      <Helmet>
        <title>{translate('repIdentityVerificationError', recheckProcessTranslation)}</title>
      </Helmet>
      <MainContainer>
        <PageHeader title={translate('somethingWentWrong', recheckProcessTranslation)} />
        <p>{translate('recheckIdNoConnected', recheckProcessTranslation)}</p>
      </MainContainer>
    </>
  );
}
